(()=> {
  // --- clear the announcement banner, whose height is not a constant ---
  // It is fixed at the top with a higher z-index than the mobile bar, and its
  // text wraps to two lines on a phone. Measuring beats guessing: a hardcoded
  // 34px assumed one line and left the bar half-covered on every phone.
  const banner = document.querySelector('.announcement-bar');
  if (banner) {
    const GAP = 12; // same breathing room the bar has without a banner
    const setBarOffset = () => {
      const height = banner.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--rk-pill-top', (height + GAP) + 'px');
    };
    setBarOffset();
    // Rotating the device rewraps the text and changes that height
    if (window.ResizeObserver) new ResizeObserver(setBarOffset).observe(banner);
    else window.addEventListener('resize', setBarOffset, { passive: true });
  }

  // --- publish how far down the page has to start to clear the nav ---
  // Whichever bar is on screen, plus air. A page whose first section sits
  // under the nav has been fixed twice by hand now, both times with a literal
  // that was right for one breakpoint. offsetHeight and the computed `top`,
  // never getBoundingClientRect: the bar hides by transform, and a rect would
  // report it as gone and collapse the clearance mid-scroll.
  const GAP = 12;
  const publishClearance = () => {
    const bars = [document.querySelector('.rk-float-nav'), document.querySelector('.rk-mobile-pill')];
    let clearance = 0;
    bars.forEach((bar) => {
      if (!bar || getComputedStyle(bar).display === 'none') return;
      const top = parseFloat(getComputedStyle(bar).top) || 0;
      clearance = Math.max(clearance, top + bar.offsetHeight + GAP);
    });
    document.documentElement.style.setProperty('--rk-nav-clearance', Math.round(clearance) + 'px');
  };
  publishClearance();
  window.addEventListener('resize', publishClearance, { passive: true });
  // the banner measurement above moves --rk-pill-top, which moves the bar
  if (banner && window.ResizeObserver) new ResizeObserver(publishClearance).observe(banner);

  // --- navigation hide-on-scroll (mobile pill + desktop nav) ---
  const navs = document.querySelectorAll('[data-rk-mobile-pill], [data-rk-desktop-nav]');

  if (navs.length) {
    let lastScrollY = window.scrollY;
    const THRESHOLD = 8; // ignore sub-threshold jitter so the nav doesn't flicker
    const setHidden = (hidden) => navs.forEach((nav) => nav.classList.toggle('rk-nav--hidden', hidden));

    window.addEventListener('scroll', () => {
      const currentScrollY = Math.max(0, window.scrollY); // clamp iOS rubber-band overscroll
      const delta = currentScrollY - lastScrollY;
      if (Math.abs(delta) < THRESHOLD) return;
      // Hide on scroll down, show on scroll up; always show near the top
      setHidden(delta > 0 && currentScrollY > 80);
      lastScrollY = currentScrollY;
    }, { passive: true });

    setHidden(false);
  }

  // --- hoverborder grid: desktop CTA ---
  const desktopCta = document.querySelector('[data-rk-cta]');
  if (desktopCta) {
    const grid = desktopCta.querySelector('.rk-cta__grid');
    if (grid) {
      const COLS = 36, ROWS = 12;
      const ripple = document.createElement('div');
      ripple.className = 'rk-cta__ripple';
      for (let i = 0; i < COLS * ROWS; i++) {
        const cell = document.createElement('span');
        cell.className = 'rk-cta__grid-cell';
        // Each cell positions the ripple to where the mouse entered
        const row = Math.floor(i / COLS);
        const col = i % COLS;
        const top  = (0.125 + row * 0.25) + 'em';
        const left = (0.1875 + col * 0.25) + 'em';
        cell.addEventListener('mouseenter', () => {
          ripple.style.top  = top;
          ripple.style.left = left;
        });
        grid.appendChild(cell);
      }
      grid.appendChild(ripple);
    }
  }

  // --- active state: highlight current page in both navs ---
  const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
  document.querySelectorAll('[data-rk-route]').forEach(function(link) {
    const route = link.getAttribute('data-rk-route').replace(/\/$/, '') || '/';
    if (route === currentPath) link.classList.add('is-active');
  });

  // --- mobile pill: keep the active (expanded) item in view — the bar can overflow on narrow screens ---
  const pillBar = document.querySelector('.rk-mobile-pill');
  const activeItem = pillBar ? pillBar.querySelector('a.is-active') : null;
  if (activeItem) {
    const centerActive = () => {
      pillBar.scrollLeft = activeItem.offsetLeft - (pillBar.clientWidth - activeItem.offsetWidth) / 2;
    };
    centerActive();
    // The label takes its full width in one go now, so there is no animation to
    // wait out. Waiting on animationend used to serve as the settle point and
    // cost a second visible scroll jump 300ms in; the webfont is the only thing
    // that still moves the width after this runs, so wait on that instead.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(centerActive);
    // ...and again after a rotation, which changes clientWidth without a reflow
    // of scrollLeft. Without this the active item sits off-centre in landscape.
    window.addEventListener('resize', centerActive, { passive: true });
  }

  // --- click ripple: both CTAs ---
  document.querySelectorAll('.rk-float-nav__cta, .rk-mobile-pill__cta').forEach(btn => {
    btn.addEventListener('click', function(e) {
      const rect = btn.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height) * 2;
      const x = e.clientX - rect.left - size / 2;
      const y = e.clientY - rect.top  - size / 2;
      const ripple = document.createElement('span');
      ripple.className = 'rk-cta__click-ripple';
      ripple.style.cssText = `width:${size}px;height:${size}px;left:${x}px;top:${y}px`;
      btn.appendChild(ripple);
      ripple.addEventListener('animationend', () => ripple.remove());
    });
  });

  // --- parent active state: the Platform entry lights up on any of its child pages ---
  document.querySelectorAll('[data-rk-parent-routes]').forEach(function(el) {
    const routes = el.getAttribute('data-rk-parent-routes')
      .split(',')
      .map((route) => route.trim().replace(/\/$/, ''));
    if (routes.includes(currentPath)) el.classList.add('is-active');
  });

  // --- desktop panels: one controller per trigger, opening one closes the rest ---
  const desktopNav = document.querySelector('[data-rk-desktop-nav]');
  const panels = [];

  if (desktopNav) {
    const CLOSE_DELAY = 160;   // grace period while the pointer crosses the gap
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

    document.querySelectorAll('[data-rk-suite-trigger]').forEach((trigger) => {
      const panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;

      let hoverTimer = null;
      let hideTimer = null;

      const isOpen = () => trigger.getAttribute('aria-expanded') === 'true';

      const close = () => {
        clearTimeout(hoverTimer);
        if (!isOpen()) return;
        panel.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        hideTimer = setTimeout(() => {
          if (!isOpen()) panel.hidden = true;
        }, 300);
      };

      const open = () => {
        clearTimeout(hoverTimer);
        clearTimeout(hideTimer);
        if (isOpen()) return;
        panels.forEach((other) => { if (other.trigger !== trigger) other.close(); });
        // anchor the panel to the live bottom edge of the bar, not to a guessed height
        panel.style.setProperty('--rk-suite-top', desktopNav.getBoundingClientRect().bottom + 'px');
        // a narrow panel hangs under its own trigger; a wide one stays centred on the page
        if (panel.classList.contains('rk-suite--narrow')) {
          const t = trigger.getBoundingClientRect();
          const half = panel.offsetWidth / 2 || 200;
          const centre = Math.min(Math.max(t.left + t.width / 2, half + 16), window.innerWidth - half - 16);
          panel.style.setProperty('--rk-suite-left', centre + 'px');
        }
        panel.hidden = false;
        void panel.offsetWidth; // flush layout so the transition has a start state
        panel.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      };

      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        isOpen() ? close() : open();
      });

      if (canHover.matches) {
        [trigger, panel].forEach((el) => {
          el.addEventListener('mouseenter', open);
          el.addEventListener('mouseleave', () => {
            clearTimeout(hoverTimer);
            hoverTimer = setTimeout(close, CLOSE_DELAY);
          });
        });
      }

      // a hash link inside the panel navigates without a reload, so close it by hand
      panel.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));

      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || !isOpen()) return;
        close();
        trigger.focus();
      });

      document.addEventListener('click', (e) => {
        if (!isOpen()) return;
        if (panel.contains(e.target) || trigger.contains(e.target)) return;
        close();
      });

      document.addEventListener('focusin', (e) => {
        if (!isOpen()) return;
        if (panel.contains(e.target) || trigger.contains(e.target)) return;
        close();
      });

      // the bar slides away on scroll, so the panel must not stay behind on its own
      window.addEventListener('scroll', () => { if (isOpen()) close(); }, { passive: true });
      window.addEventListener('resize', () => { if (isOpen()) close(); }, { passive: true });

      panels.push({ trigger, close });
    });
  }

  // --- mobile sheets: same pairing, one open at a time ---
  const sheets = [];

  document.querySelectorAll('[data-rk-sheet-trigger]').forEach((trigger) => {
    const sheet = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!sheet) return;

    let hideTimer = null;
    const isOpen = () => trigger.getAttribute('aria-expanded') === 'true';

    const close = () => {
      if (!isOpen()) return;
      sheet.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.documentElement.classList.remove('rk-sheet-open');
      hideTimer = setTimeout(() => {
        if (!isOpen()) sheet.hidden = true;
      }, 320);
    };

    // The list can run past the panel's 74vh cap. Fade the bottom edge while
    // there is more to reach, and stop once the end is on screen — a permanent
    // fade reads as "always more" and is its own kind of lie. Measured after
    // the panel is laid out, never from a guessed row count.
    const scroller = sheet.querySelector('.rk-sheet__scroll');
    const markOverflow = () => {
      if (!scroller) return;
      const remaining = scroller.scrollHeight - scroller.clientHeight - scroller.scrollTop;
      scroller.classList.toggle('rk-sheet__scroll--more', remaining > 8);
    };
    if (scroller) scroller.addEventListener('scroll', markOverflow, { passive: true });

    const open = () => {
      clearTimeout(hideTimer);
      sheets.forEach((other) => { if (other.trigger !== trigger) other.close(); });
      sheet.hidden = false;
      void sheet.offsetWidth;
      sheet.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      // Lets the bar lift itself above the drawer's backdrop and dim its own
      // items, so the tab you opened stays readable. A class rather than
      // :has(.rk-sheet.is-open) at document level, which the engine would have
      // to re-evaluate against the whole tree.
      document.documentElement.classList.add('rk-sheet-open');
      // hidden until this point, so height only becomes readable now
      markOverflow();
    };

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      isOpen() ? close() : open();
    });

    sheet.querySelectorAll('[data-rk-sheet-close]').forEach((el) => el.addEventListener('click', close));
    sheet.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen()) close();
    });

    sheets.push({ trigger, close });
  });
})();